import { render } from "./SeTextarea.vue?vue&type=template&id=65175362&scoped=true&ts=true"
import script from "./SeTextarea.vue?vue&type=script&lang=ts"
export * from "./SeTextarea.vue?vue&type=script&lang=ts"

import "./SeTextarea.vue?vue&type=style&index=0&id=65175362&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65175362"]])

export default __exports__